module.exports = __webpack_public_path__ + "static/img/tx.63ff5ce6.jpeg";